// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"40517526","453":"25cb786d","455":"cde7594e","977":"fa6d2160"}[chunkId] + ".chunk.js";
};